import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import SEOHead from "@/components/SEOHead";

const InboxCheck = () => {
  const { user } = useAuth();
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    if (!user) return;
    setSaving(true);

    await supabase
      .from("profiles")
      .update({ inbox_prompt_seen: true })
      .eq("user_id", user.id);

    // Use hard navigation so ProtectedRoute re-fetches fresh profile data
    window.location.href = "/dashboard";
  };

  return (
    <>
      <SEOHead title="Check your inbox — Dearestly." description="Confirm your Dearestly. email so reminders land safely." path="/inbox-check" noindex />
      <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm">
        <div className="rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
          <p className="mb-6 text-[56px] leading-none">📬</p>

          <h1 className="mb-4 font-serif text-2xl font-semibold text-foreground">
            Check your inbox
          </h1>

          <p className="mx-auto mb-4 max-w-[280px] text-sm leading-relaxed text-muted-foreground">
            We just sent you a welcome email from{" "}
            <span className="font-medium text-foreground">
              noreply@circle.dearestly.co
            </span>
            .
          </p>

          <p className="mx-auto mb-6 max-w-[280px] text-sm leading-relaxed text-muted-foreground">
            If it landed in your spam folder, please mark it as "Report as not
            spam" and add us to your contacts — this makes sure your birthday
            reminders always get through.
          </p>

          <p className="mb-8 text-xs leading-relaxed text-muted-foreground/70">
            Using Gmail? Open the email, click the three dots (⋮), and select
            "Report as not spam".
          </p>

          <Button
            onClick={handleConfirm}
            disabled={saving}
            className="w-full rounded-full"
            size="lg"
          >
            {saving ? "Saving…" : "Got it, I'll check now"}
          </Button>
        </div>
      </div>
    </div>
  </>
  );
};

export default InboxCheck;
